import React, { Component } from 'react'
import AuthContext from "context/AuthProvider";
import { withRouter } from "react-router-dom";
import { showLoadingScreen,hideLoadingScreen} from "components/LoadingScreen";

export class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userData : null, 
            isEmployee : true,
            quickSearchClass: "quick-search-div"        
        }
    }

    componentDidMount(){
        const sessionUserData = JSON.parse(this.context.getUserDetails());
        
        this.setState({
            userData : sessionUserData,
            isEmployee : sessionUserData ? (sessionUserData.profile === "employee" ? true : false) : false,
            isEmployer : sessionUserData ? (sessionUserData.profile === "employer" ? true :false) :false,
            quickSearchClass: sessionUserData ? (sessionUserData.profile === "employee" ? "" : "quick-search-div") : "quick-search-div",
         })
    }
    
    searchHandle = async (city) => {
        let regionValues = [city].join("_");
        window.location.href = `/search-jobs/null/${regionValues}`
    }

    showLoginPageHandler = (event) => {
        event.preventDefault();
        if(this.state.userData ===null){
            window.location.href = "/#login"
            window.indexComponent.showLoginPopup();    
        }
    }
    browseJobBtn = (event) => {
        event.preventDefault();
        showLoadingScreen();
        if(this.state.isEmployer){
            this.props.history.push("/jobprovider-jobs");
        }
        else{
            this.props.history.push("/all-jobs");
        }        
        hideLoadingScreen();
    }

    PostJobBtn = (event) => {
        event.preventDefault();
        if(this.state.userData !==null){
            if(this.state.isEmployer){
               this.props.history.push("/job-post-page/new-post");
            }
        }
        else{
            window.location.href ="/#login"
            window.indexComponent.showLoginPopup();
        }
        
    }
    popularCitiesBtn = (event) => {
        event.preventDefault();
        const popularCity = ["delhi","mumbai","pune","kolkata","chennai","bengaluru"];
        this.props.history.push({
            pathname:"/search-jobs",
            state:{
                keyword : "",
                region : popularCity,
            }
        });
        window.location.reload();
    }

    render() {
        return (
            <footer>
                <div className="fi">
                    <div className="ft">
                        <div>
                            <div className="fm">We measure success not just in certificates, but in livelihoods created.
                            </div>
                            <div className="ftg">One Skill. One Job. One Livelihood.</div>
                            <div className="fcr">Aligned with NSDC<br />THSC Certified Programmes<br />Ministry of Skill Development and
                                Entrepreneurship</div>
                        </div>
                        <div className="fl">
                            <div className="fc">
                                <div className="fc-t">The Job Plus</div>
                                <a href="/pages/about-us-page.html">About Us</a>
                                <a href="/contact-us-page">Contact Us</a>
                                <a href="/privacy-policy">Privacy Policy</a>
                                {/* <a href="/terms-of-use">Terms of Use</a> */}
                            </div>
                            <div className="fc">
                                <div className="fc-t">Our Services</div>
                                <a href="/home.html#rtd">Recruit-Train-Deploy</a>
                                <a href="/home.html#csr">CSR-Powered Skilling</a>
                            </div>
                            <div className="fc">
                                <div className="fc-t">Partners</div>
                                <a href="/home.html#home-employer-partners">Employer Partners</a>
                                {/* <a href="/pages/partners-page.html#educational-partner">Training Partners</a>
                                <a href="/pages/partners-page.html#alliance-partner">Strategic Partners</a> */}
                            </div>
                            <div className="fc">
                                <div className="fc-t">Connect</div>
                                <a href="https://www.linkedin.com/company/thejobplus/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                <a href="https://www.instagram.com/the_jobplus/" target="_blank" rel="noopener noreferrer">Instagram</a>
                                <a href="https://www.facebook.com/The-Job-Plus-102185892561845" rel="noopener noreferrer" target="_blank">Facebook</a>
                                {/* <a href="/blogs#our-blogs" target="_blank" rel="noopener noreferrer">Blog</a> */}
                            </div>
                        </div>
                    </div>
                    <div className="fb">
                        <div>Copyright 2026, The Job Plus. All Rights Reserved.</div>
                        <div>thejobplus.com</div>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.contextType = AuthContext;
 export default withRouter(Footer);
